import { render, staticRenderFns } from "./DeleteXomeConfirm.vue?vue&type=template&id=1081ff34&"
import script from "./DeleteXomeConfirm.vue?vue&type=script&lang=js&"
export * from "./DeleteXomeConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports